export default "__VITE_ASSET__BEponBUG__"